// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"e9355c019284355e377c","562":"394d56788eb758f63466","686":"ffda914bcdc7e575c2e7","812":"6b5bc50c36d0fc746650"}[chunkId] + ".chunk.js";
};